import { create } from 'zustand';

export type CalendarView = 'day' | 'week' | 'month' | 'timeline';

interface CalendarFilters {
  selectedCaregivers: string[];
  statusFilter: string[];
  searchQuery: string;
}

interface CalendarState {
  view: CalendarView;
  currentDate: Date;
  filters: CalendarFilters;
  selectedAssignmentId: string | null;

  setView: (view: CalendarView) => void;
  setCurrentDate: (date: Date) => void;
  setSelectedCaregivers: (ids: string[]) => void;
  setStatusFilter: (statuses: string[]) => void;
  setSearchQuery: (query: string) => void;
  setSelectedAssignment: (id: string | null) => void;
  resetFilters: () => void;
}

const initialFilters: CalendarFilters = {
  selectedCaregivers: [],
  statusFilter: [],
  searchQuery: '',
};

export const useCalendarStore = create<CalendarState>((set) => ({
  view: 'month',
  currentDate: new Date(),
  filters: initialFilters,
  selectedAssignmentId: null,

  setView: (view) => set({ view }),

  setCurrentDate: (date) => set({ currentDate: date }),

  setSelectedCaregivers: (ids) =>
    set((state) => ({
      filters: { ...state.filters, selectedCaregivers: ids },
    })),

  setStatusFilter: (statuses) =>
    set((state) => ({
      filters: { ...state.filters, statusFilter: statuses },
    })),

  setSearchQuery: (query) =>
    set((state) => ({
      filters: { ...state.filters, searchQuery: query },
    })),

  setSelectedAssignment: (id) => set({ selectedAssignmentId: id }),

  resetFilters: () => set({ filters: initialFilters }),
}));
